let current = 0;

// Returns a unique (incrementing) numeric ID for the current session
export default () => (current ++);
